// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs__container___Nsf60","interactiveSecondary":"Breadcrumbs__interactiveSecondary___iy14N","button":"Breadcrumbs__button___sAl0A"};